// extracted by mini-css-extract-plugin
export default {"button":"SpinnerButton_button__m0IIM","loading":"SpinnerButton_loading__nyKec","spinner":"SpinnerButton_spinner__B2Ab2","spin":"SpinnerButton_spin__jxYGT"};